import { Order, OrderStatuses, useGetOrdersMutation } from '@services';
import { useEffect, useState } from 'react';

export const useMyOrdersPageVM = () => {
    const [orders, setOrders] = useState<Order[]>([]);
    const [errorMessage, setErrorMessage] = useState<string>('');

    const [getOrders, { data, isLoading, isError }] = useGetOrdersMutation();

    useEffect(() => {
        getOrders();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isLoading) {
            return;
        }

        if (data) {
            setOrders(data);
        }

        if (isError) {
            setErrorMessage('Une erreur est survenue lors du chargement des commandes');
        }
    }, [data, isLoading, isError]);

    return {
        currentOrders: orders.filter((order) => order.status === OrderStatuses.CREATED),
        pastOrders: orders.filter((order) => order.status !== OrderStatuses.CREATED),
        isLoading,
        errorMessage
    };
};
